import { Company } from "models/Company"
import {  useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
import { UrlPath } from "utility/routes"
import { AccountState } from "context/AccountContext";
import { companyService } from "services/Services";
import { useState } from "react";

const CompanyConsent: React.FC<{company: Company | undefined, updateCompany : Function}> = ({company, updateCompany}) => {
    const { stateAccount } = AccountState();
    const [errorMessaage, setErrorMessage] = useState(""); 
     let navigate = useNavigate();
    const formik = useFormik({
      initialValues:{
        access: false,
      },
      onSubmit: async (values) => {
        setErrorMessage("");
        const newCompany = {
          ...company,
          isConsentGiven: true
          }
        await companyService.addUserConcent(newCompany.companyCode as string, newCompany.id as string).then(()=>{
          stateAccount.updateCompany(newCompany as Company);
          updateCompany(newCompany);
        })
      },validate: (values)=>{
        let errors = {};
          if (!values.access) {
            errors ={access:'Required'};
            setErrorMessage("Må bekreftes.");
        }
        return errors;
      }

    });

    const onCancelForm = ()=> {
      console.log('CANCEL', company);
      stateAccount.removeCompany(company as Company);
      navigate(`${UrlPath.MyAccount.Home}`);
    }

    return <>
    <div className="card">
    <div className="card-body">
      <h1 className="h3">{company?.name}</h1>
      <p className="text-secondary">Org nr: {company?.companyCode}. Juridisk navn: {company?.legalName}</p>
    
    <form onSubmit={e => {
    //console.log("isValid", formik.isValid);
    if(formik.isValid)
    {formik.handleSubmit(e)}
    else{
      e.preventDefault();e.stopPropagation();
    }
  }} className="needs-validation" noValidate>
      <>
      <div className="form-check mb-4">
        <input className="form-check-input" type="checkbox" required onChange={formik.handleChange} value="" id="access"></input>
        <label className="form-check-label small" htmlFor="access"> Jeg har eierskap eller tillatelse på vegne av denne bedriften til å endre eller legge til opplysninger. Jeg godkjenner at opplysningene kan vises i alle 1881s tjenester og at informasjonen er korrekt og oppdatert. Jeg garanterer at informasjonen er i overensstemmelse med norsk lov, god forretningsskikk, god markedsføringsskikk og god reklameskikk. Støtende og upassende innhold vil fjernes uten varsel. </label>
        {errorMessaage && (
          <div className="alert alert-danger mt-4">{errorMessaage}</div>
        )}
      </div>
      <p className="mt-4 mb-0">
        <button type="submit" disabled={formik.isSubmitting} className="btn btn-primary" >Gå videre</button>
        <button className="btn btn-outline-primary ms-2" type="button"  onClick={() => onCancelForm()}>Avbryt</button>
      </p>
        </>
        </form>
    </div>
  </div>
    </>
}

export default CompanyConsent